export type ResultPublicationDocument = {
  name: string;
  url: string;
  pdfUrl: string;
  startAt: string;
  endAt: string;
  updatedAt: string;
  updatedBy: string;
};

export type ResponseResultPublicationDocument = {
  document_name: string;
  document_updated_at: string;
  document_updated_user_name: string;
  startdate_at: string;
  enddate_at: string;
  document_url: string;
  pdf_url: string;
};

export const buildResultPublicationDocument = (
  res: ResponseResultPublicationDocument,
): ResultPublicationDocument => {
  return {
    name: res.document_name,
    url: res.document_url,
    pdfUrl: res.pdf_url,
    startAt: res.startdate_at,
    endAt: res.enddate_at,
    updatedAt: res.document_updated_at,
    updatedBy: res.document_updated_user_name,
  };
};
